module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"placeholder-ingredients":"Flour\\nEggs\\nMilk"},"de":{"Pancakes":"Pfannkuchen","placeholder-ingredients":"Mehl\\nEier\\nMilch","Name":"Name","Ingredients":"Zutaten"}}')
  delete Component.options._Ctor
}
